/**
 * Services Sections Navigation
 * Highlights active nav item based on scroll position using IntersectionObserver
 */

export default class ServicesSectionsNav {
  constructor(element) {
    this.nav = element;
    this.links = this.nav.querySelectorAll('a[href^="#"]');
    this.sections = [];

    // Collect section elements based on nav links
    this.links.forEach((link) => {
      const id = link.getAttribute('href').substring(1);
      const section = document.getElementById(id);
      if (section) {
        this.sections.push({ id, element: section, link });
      }
    });

    this.init();
  }

  init() {
    if (this.sections.length === 0) return;

    // Use IntersectionObserver for efficient scroll detection
    // Trigger when section is in upper portion of viewport
    let options = { rootMargin: '-20% 0px -70% 0px', threshold: 0 };
    this.observer = new IntersectionObserver((entries) => this.handleIntersect(entries), options);

    this.sections.forEach(({ element }) => {
      this.observer.observe(element);
    });
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.setActiveLink(entry.target.id);
      }
    });
  }

  setActiveLink(activeId) {
    this.links.forEach((link) => {
      const id = link.getAttribute('href').substring(1);
      link.classList.toggle('active', id === activeId);
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/services-sections-nav.js